// extracted by mini-css-extract-plugin
export default {"icon":"ErrorView_icon__cnmj2"};